import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiService } from '../services/api.service';

interface Vendor {
  id: number;
  name?: string;
  qBO_Vendor_Id?: number;
}

@Component({
  standalone: true,
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrl: './vendors.component.css',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule
  ]
})
export class VendorsComponent implements OnInit {
  dataSource = new MatTableDataSource<Vendor>([]);
  displayedColumns: string[] = ['name', 'qBO_Vendor_Id'];
  loading: boolean = true;
  error: string | null = null;

  @ViewChild(MatSort) set matSort(s: MatSort) {
    if (s) { this.dataSource.sort = s; }
  }

  @ViewChild(MatPaginator) set matPaginator(p: MatPaginator) {
    if (p) { this.dataSource.paginator = p; }
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadVendors();
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadVendors(): void {
    this.loading = true;
    this.error = null;
    
    console.log('Loading vendors from API...');
    
    this.apiService.get<any>('vendor/all').subscribe({
      next: (data) => {
        console.log('API Response received:', data);
        console.log('Response type:', typeof data);
        
        let vendorsArray: any[] = [];
        
        // Handle both array and object responses
        if (Array.isArray(data)) {
          vendorsArray = data;
        } else if (data && typeof data === 'object') {
          // If the data is wrapped in a property, try common property names
          vendorsArray = data.vendors || data.Vendors || data.data || data.Data || [];
        }
        
        console.log('Vendors array:', vendorsArray);
        
        // Map to ensure consistent property names (handle both camelCase and PascalCase)
        const vendors = vendorsArray.map((vendor: any) => ({
          id: vendor.id || vendor.Id,
          name: vendor.name || vendor.Name,
          qBO_Vendor_Id: vendor.qBO_Vendor_Id || vendor.QBO_Vendor_Id || vendor.qboVendorId
        }));
        
        console.log('Processed vendors:', vendors);
        
        this.dataSource.data = vendors;
        this.loading = false;
        
        // Force change detection
        this.cdr.detectChanges();
        
        console.log('Vendors loaded successfully');
      },
      error: (err) => {
        console.error('Error loading vendors:', err);
        this.error = `Failed to load vendors: ${err.message || 'Unknown error'}`;
        this.loading = false;
        
        // Force change detection
        this.cdr.detectChanges();
      }
    });
  }

  createVendor(): void {
    this.router.navigate(['/vendors/new']);
  }

  editVendor(vendor: Vendor): void {
    this.router.navigate(['/vendors', vendor.id]);
  }

  deleteVendor(vendor: Vendor): void {
    if (confirm(`Are you sure you want to delete vendor "${vendor.name}"?`)) {
      this.apiService.delete(`vendor/${vendor.id}`).subscribe({
        next: () => {
          console.log('Vendor deleted successfully');
          this.loadVendors();
        },
        error: (err) => {
          console.error('Error deleting vendor:', err);
          this.error = `Failed to delete vendor: ${err.message || 'Unknown error'}`;
        }
      });
    }
  }
}
